import { restaurantInfo } from '@/mocks/restaurantData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 reveal">
        <div className="inline-flex items-center gap-2 text-primary-400 font-script text-5xl">
        &mdash; Contact &mdash;
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-6 leading-[1.35]">
            お問い合わせ・ご予約
          </h2>
          <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-lg mx-auto">
            ご予約やお問い合わせはお電話にて承っております。<br />
            お気軽にご連絡ください。
          </p>
        </div>

        <div className="reveal">
          <div className="bg-background-100 rounded-3xl p-10 md:p-14 text-center">
            <div className="w-16 h-16 md:w-18 md:h-18 mx-auto mb-6 rounded-full bg-primary-500/10 flex items-center justify-center">
              <i className="ri-phone-line text-3xl text-primary-400"></i>
            </div>

            <a
              href={`tel:${restaurantInfo.phone}`}
              className="block font-heading text-3xl md:text-4xl font-bold text-foreground-950 hover:text-primary-400 transition-colors duration-300 mb-8"
            >
              {restaurantInfo.phone}
            </a>

            <div className="flex items-center justify-center gap-6 md:gap-8">
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className="ri-instagram-line text-2xl text-foreground-400 group-hover:text-primary-400 transition-colors duration-300"></i>
                </div>
                <span className="text-foreground-300 font-heading text-base">Instagram</span>
              </a>

              <a
                href="https://line.me/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 flex items-center justify-center group-hover:bg-accent-500/20 transition-colors duration-300">
                  <i className="ri-line-line text-2xl text-foreground-400 group-hover:text-accent-400 transition-colors duration-300"></i>
                </div>
                <span className="text-foreground-300 font-heading text-base">LINE</span>
              </a>

              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200 flex items-center justify-center group-hover:bg-foreground-100/10 transition-colors duration-300">
                  <i className="ri-twitter-x-line text-2xl text-foreground-400 group-hover:text-foreground-600 transition-colors duration-300"></i>
                </div>
                <span className="text-foreground-300 font-heading text-base">X</span>
              </a>
            </div>
          </div>
        </div>

        <div className="text-center mt-10 reveal">
          <p className="text-foreground-300 text-xs leading-relaxed">
            営業時間内にお電話が繋がりにくい場合は、<br className="sm:hidden" />
            SNSのDMからもお問い合わせいただけます。
          </p>
        </div>
      </div>
    </section>
  );
}